import type { ReactElement } from 'react';
import { useUIDSeed } from 'react-uid';

type ListItem = {
  label: string;
  quantity: Record<string, number>;
}

type Props = {
  list: ListItem[];
  planName: string;
};

function ItemizedList({ list, planName }: Props): ReactElement {
  const seed = useUIDSeed();

  return (
    <div className="c-itemized-list">
      {list.filter((item) => item.quantity[planName] > 0).map((listItem, index) => (
        <div key={seed(index)}>
          <hr />
          <div className="c-itemized-list__row">
            <div className="u-text--xs">{listItem.label}</div>
            <div className="c-itemized-list__quantity">{listItem.quantity[planName]}</div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default ItemizedList;
